export default "__VITE_ASSET__e2636589__"